<template>
  <dialog id="dialog" class="mdl-dialog">
    <h3 class="mdl-dialog__title">{{ dialog.title }}</h3>
    <div class="mdl-dialog__content">
      <div v-if="dialog.isHTML" v-html="dialog.content" class="html"></div>
      <div v-else>{{ dialog.content }}</div>
    </div>
    <div class="mdl-dialog__actions">
      <button type="button" class="mdl-button" @click="accept()">Aceptar</button>
      <button type="button" class="mdl-button">Cerrar</button>
    </div>
  </dialog>
</template>

<script>
export default {
  data () {
    return {
      dialog: {
        el: '',
        title: '',
        content: '',
        isHTML: false
      }
    }
  },
  methods: {
    show (title, content, isHTML) {
      this.dialog.title = title
      this.dialog.content = content
      this.dialog.el.showModal()
      this.dialog.isHTML = isHTML
    },
    accept () {
      this.$dialog.accept()
    }
  },
  mounted () {
    const dialog = document.querySelector('#dialog')

    if (!dialog.showModal) {
      dialogPolyfill.registerDialog(dialog)
    }

   dialog.querySelector('.mdl-dialog__actions')
    .addEventListener('click', function(event) {
      if (event.target.classList.contains('mdl-button')) {
        dialog.close()
      }
    })

    this.dialog.el = dialog
    this.$dialog.show = this.show
  }
}
</script>

<style lang="css" scoped>
  .mdl-dialog {
    border: none;
    box-shadow: 0 9px 46px 8px rgba(0, 0, 0, 0.14),
      0 11px 15px -7px rgba(0, 0, 0, 0.12),
      0 24px 38px 3px rgba(0, 0, 0, 0.2);
    width: 320px;
  }
  .mdl-dialog__title {
    padding: 24px 24px 0;
    margin: 0;
    font-size: 1.5rem;
  }
  .mdl-dialog__actions {
    padding: 8px 8px 8px 24px;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: row-reverse;
    -ms-flex-direction: row-reverse;
    flex-direction: row-reverse;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }
  .mdl-dialog__actions > * {
    margin-right: 8px;
    height: 36px;
  }
  .mdl-dialog__actions > *:first-child {
    margin-right: 0;
  }
  .mdl-dialog__actions--full-width {
    padding: 0 0 8px 0;
  }
  .mdl-dialog__actions--full-width > * {
    height: 48px;
    -webkit-flex: 0 0 100%;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    padding-right: 16px;
    margin-right: 0;
    text-align: right;
  }
  .mdl-dialog__content {
    padding: 20px 24px 24px 24px;
    color: rgba(0, 0, 0, 0.54);
  }

  .mdl-dialog__content .html {
    display: flex;
    flex-direction: column;
  }
</style>


// WEBPACK FOOTER //
// index.vue?0a1751e6